import AssetsCoin from '@/assets/image/useCases/tokenizedRWA/assets_coin2.png'
import '@/assets/scss/global.scss';
import './index.scss'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const TokenizedRWAFoot = () => {
  const isDesktop = useMediaQuery({ minWidth: 769 });
   return (
     <div className='tokenized-RWA-foot'>
       {
         isDesktop ? (
           <div className={`w-1340 pt-[220px] pb-[140px] tokenized-RWA-foot-item pl-[192px] pr-[192px] text-[#fff] text-left flex items-start justify-center`}>
             <div>
               <div className={`tokenized-RWA-foot-title text-[64px]`}>
                 $250,000,000
               </div>
               <div className={`tokenized-RWA-foot-desc text-[18px]`}>
                 tokenized MMFs and stocks in the Q4 pipeline
               </div>
               <div className={`get-touch-btn mt-[30px]`}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>
             <div className={`flex items-center ml-[26px] mt-[-80px]`}>
               <img src={AssetsCoin} className={`h-[160px]`} />
             </div>
           </div>
         ) : (
           <div
             className={`w-1340 pt-[80px] pb-[80px] tokenized-RWA-foot-item text-[#fff]`}>
             <div className={`flex items-center justify-center mb-[40px]`}>
               <img src={AssetsCoin} className={`h-[160px]`} />
             </div>
             <div className={`text-center`}>
               <div className={`tokenized-RWA-foot-title text-[20px] mb-[20px]`}>
                 $250,000,000
               </div>
               <div className={`tokenized-RWA-foot-desc text-[14px] mb-[20px]`}>
                 tokenized MMFs and stocks in the Q4 pipeline
               </div>
               <div className={`get-touch-btn`} style={{ margin: '0 auto' }}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`get-touch-btn-text`}>Get In Touch</div>
                 </Link>
                 <div className={`get-touch-mask`} />
               </div>
             </div>

           </div>
         )
       }

     </div>

   )
}

export default TokenizedRWAFoot